import { create } from "zustand";

import type { CatalogView } from "@/music-catalog/components/music-catalog-page/catalog-toolbar";

interface CatalogViewState {
  setView: (view: CatalogView) => void;
  view: CatalogView;
}

/**
 * Whether the catalog is drawn as covers or as tracks.
 *
 * Held above the page rather than in it, so opening a project from the tracks
 * view and coming back — by the back link or the browser — returns to the
 * tracks view instead of starting over at covers. Kept for as long as the tab
 * is open and no longer: it is where the reader was, not a preference.
 */
export const useCatalogViewStore = create<CatalogViewState>((set) => ({
  setView: (view) => set({ view }),
  view: "covers",
}));
